import { normalizeId } from '@telia-common-components/shared';
import React from 'react';
import { Accordion, AccordionContent, AccordionHeader, AccordionItem, AccordionTitle, Button, Chip, ChoiceGroup, Grid, GridColumn, Heading, Modal, ModalCloser, ModalContent, ModalHeader, ModalProvider, ModalTrigger, Separator, useAnalytics } from 'telia-front-react';
const TvComparisonMobileFilter = (props) => {
    const { packageNames, themeNames, appNames, serviceNames, translate, filterState, filterActions, hideApps } = props;
    const { push: pushAnalytics } = useAnalytics();
    const clearAllFilters = () => {
        const { setSelectedThemes, setSelectedServices, setSelectedPackages, setSelectedApps } = filterActions;
        setSelectedThemes([]);
        setSelectedServices([]);
        setSelectedPackages([]);
        setSelectedApps([]);
    };
    const selectFilter = (checked, filterName, currentSelections, setSelections) => {
        let newSelections = currentSelections.slice();
        if (checked) {
            newSelections.push(filterName);
        }
        else {
            newSelections = newSelections.filter((name) => name !== filterName);
        }
        setSelections(newSelections);
    };
    const renderFilterSection = (filterSectionProps) => {
        const { type, title, allFilters, activeFilters, onActiveFiltersChange } = filterSectionProps;
        return (React.createElement(AccordionItem, { id: `tv-comparison-filter-${type}`, onToggle: (isOpen) => pushAnalytics(`${isOpen ? 'Open' : 'Close'} filter section - ${type}`) },
            React.createElement(AccordionHeader, null,
                React.createElement(AccordionTitle, null, title)),
            React.createElement(AccordionContent, null,
                React.createElement(ChoiceGroup, { id: `tv-comparison-filter-choices-${type}`, label: title, hideLabel: true, type: "check", value: activeFilters.slice(), defaultValue: activeFilters.slice(), onChange: (value) => {
                        onActiveFiltersChange(value);
                        pushAnalytics(`Change filter ${type} - ${value}`);
                    }, options: allFilters.map((filterName) => ({
                        id: normalizeId(`tv-comparison-filter-${type}-${filterName}`),
                        labelText: translate(`tvcomparison.filter.${type}.${filterName}`) || filterName,
                        value: filterName
                    })) }),
                React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }))));
    };
    const renderFilterChip = (type, filterName, onRemove) => {
        return (React.createElement(GridColumn, { width: ['min-xs'], key: `${type}-filter-chip-${filterName}` },
            React.createElement(Chip, { onRemove: () => onRemove(filterName) }, translate(`tvcomparison.filter.${type}.${filterName}`) || filterName)));
    };
    const renderFilterChips = () => {
        const { selectedPackages, selectedThemes, selectedApps, selectedServices } = filterState;
        const hasActiveFilters = selectedPackages.length || selectedThemes.length || selectedApps.length || selectedServices.length;
        if (hasActiveFilters) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
                React.createElement("p", { className: "sr-only" }, translate('tvcomparison.filter.activeFilters')),
                React.createElement(Grid, { gutter: "xsmall" },
                    selectedPackages.map((packageName) => renderFilterChip('package', packageName, (filterName) => selectFilter(false, filterName, filterState.selectedPackages, filterActions.setSelectedPackages))),
                    selectedApps.map((appName) => renderFilterChip('app', appName, (filterName) => selectFilter(false, filterName, filterState.selectedApps, filterActions.setSelectedApps))),
                    selectedThemes.map((themeName) => renderFilterChip('theme', themeName, (filterName) => selectFilter(false, filterName, filterState.selectedThemes, filterActions.setSelectedThemes))),
                    selectedServices.map((serviceName) => renderFilterChip('service', serviceName, (filterName) => selectFilter(false, filterName, filterState.selectedServices, filterActions.setSelectedServices))))));
        }
        return null;
    };
    const renderFilterContent = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Heading, { level: 1, className: "h2" }, translate('tvcomparison.filter.title')),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
            React.createElement(Accordion, null,
                renderFilterSection({
                    type: 'package',
                    title: translate('tvcomparison.filter.packages'),
                    allFilters: packageNames,
                    activeFilters: filterState.selectedPackages,
                    onActiveFiltersChange: (activeFilters) => filterActions.setSelectedPackages(activeFilters)
                }),
                renderFilterSection({
                    type: 'theme',
                    title: translate('tvcomparison.filter.categories'),
                    allFilters: themeNames,
                    activeFilters: filterState.selectedThemes,
                    onActiveFiltersChange: (activeFilters) => filterActions.setSelectedThemes(activeFilters)
                }),
                !hideApps &&
                    renderFilterSection({
                        type: 'app',
                        title: translate('tvcomparison.filter.apps'),
                        allFilters: appNames,
                        activeFilters: filterState.selectedApps,
                        onActiveFiltersChange: (activeFilters) => filterActions.setSelectedApps(activeFilters)
                    }),
                renderFilterSection({
                    type: 'service',
                    title: translate('tvcomparison.filter.services'),
                    allFilters: serviceNames,
                    activeFilters: filterState.selectedServices,
                    onActiveFiltersChange: (activeFilters) => filterActions.setSelectedServices(activeFilters)
                })),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
            React.createElement(ModalCloser, null,
                React.createElement(Button, { text: translate('tvcomparison.filter.save'), iconLeft: "#filter", block: true, onClick: () => {
                        pushAnalytics('Apply filters');
                    } }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalProvider, { onToggle: (isOpen) => {
                pushAnalytics(isOpen ? 'Open filter' : 'Close filter');
            } },
            React.createElement(ModalTrigger, null,
                React.createElement(Button, { iconLeft: "#filter", block: true, variant: "secondary", size: "small", text: translate('tvcomparison.filter') })),
            React.createElement(Modal, { isFullScreen: true, hasContentComponent: true, isClosable: false },
                React.createElement(ModalHeader, null,
                    React.createElement(Grid, { noWrap: true, align: ['middle-xs', 'between-xs'] },
                        React.createElement(GridColumn, { width: ['min'] },
                            React.createElement(ModalCloser, null,
                                React.createElement(Button, { text: translate('tvcomparison.filter.back'), icon: "#arrow-left", variant: "secondary" }))),
                        React.createElement(GridColumn, { width: ['min'] },
                            React.createElement(ModalCloser, null,
                                React.createElement(Button, { text: translate('tvcomparison.filter.clear'), link: true, iconLeft: "#close", onClick: clearAllFilters }))))),
                React.createElement(ModalContent, null, renderFilterContent()))),
        renderFilterChips()));
};
export default TvComparisonMobileFilter;
